import React, {useEffect, useState} from 'react';
import {Avatar, Collapse, Divider, Layout, List, Skeleton, Tabs} from "antd";
import MyCenterMenuLayout from "../../../layouts/MyCenter/MenuLayout";
import styles from "../../MyCenter/Requests/index.module.scss";
import "../../Profile/Request/request.module.css";
import {useTranslation} from "react-i18next";
import {UserOutlined} from "@ant-design/icons";
import InfiniteScroll from "react-infinite-scroll-component";
import useFetch, {CachePolicies} from "use-http";
import Request from '../../../components/Request'
import {GroupRequests} from "./GroupRequests/GroupRequests";

const {Content, Header} = Layout
const {TabPane} = Tabs
const { Panel } = Collapse;

interface DataType {
    gender?: string;
    name: {
        title?: string;
        first?: string;
        last?: string;
    };
    email?: string;
    picture: {
        large?: string;
        medium?: string;
        thumbnail?: string;
    };
    nat?: string;
    loading: boolean;
}

const count = 6;
const fakeDataUrl = `https://randomuser.me/api/?results=${count}&inc=name,gender,email,nat,picture&noinfo`;

const Requests = (props: any) => {
    const {t} = useTranslation();
    const [initLoading, setInitLoading] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<DataType[]>([]);
    const [requestedFriends, setRequestedFriends] = useState<any>([]);
    const [pendingRequests, setPendingRequests] = useState<any>([]);
    const [groupRequests, setGroupRequests] = useState<any>([]);
    const [groupPendingRequests, setGroupPendingRequests] = useState<any>([]);
    const [totalGroupPendingRequest, setTotalGroupPendingRequest] = useState<number>(0);

    const pendingRequestAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/users/all/requested",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const allGroupPendingRequestsAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/group/requests",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    )

    const groupAcceptAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v2/groups/accept",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    )

    const acceptFriend = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/users/accept-friend",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const requestedFriendAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/users/all/pending-accept",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const groupRequestedAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/group/group-requested",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const cancelfriend = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/users/cancel-friend",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const cancelRequestGroup = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v2/groups/user-cancel-request",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const deleteRequestFriend = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/users/reject-friend",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const delRequestFriend = async (friendID: string) =>{
        const res = await cancelfriend.post({ friendID });
        if (cancelfriend.response.ok) {
            setPendingRequests((rfs: any) => rfs.filter((rf: any) => {
                return rf?.friend?.id !== friendID
            }));
        }
    }

    const cancelFriend = async (friendID: string) =>{
        const res = await deleteRequestFriend.post({ friendID });
        if (deleteRequestFriend.response.ok) {
            setRequestedFriends((rfs: any) => rfs.filter((rf: any) => {
                return rf?.friend?.id !== friendID
            }));
        }
    }

    const cancelGroup = async (groupID: string) => {
        const res = await cancelRequestGroup.post({ groupID });
        if (cancelRequestGroup.response.ok || res?.text == "record not found") {
            setGroupRequests((rfs: any) => rfs.filter((rf: any) => {
                return rf?.group?.id !== groupID
            }));
        }
    }

    const acceptRequest = async (friendID: string) => {
        const res = await acceptFriend.post({ friendID });
        if (acceptFriend.response.ok) {
            setRequestedFriends((rfs: any) => rfs.filter((rf: any) => {
                return rf?.friend?.id !== friendID
            }));
        }
    };

    const onChange = (key: string | string[]) => {
        console.log(key);
    };

    const fetchGroupRequested = async () => {
        try {
            const res = await groupRequestedAPI.get();
            console.log("res => ",res);

            if(groupRequestedAPI.response.ok){
                setGroupRequests(res);
                return
            }

        } catch (error) {
            console.error(error);
        }
    };

    const fetchFriendRequest = async () => {
        try {
            const res = await requestedFriendAPI.get();
            setRequestedFriends(res);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchPendingRequest = async () => {
        try {
            const res = await pendingRequestAPI.get();
            setPendingRequests(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchAllGroupPendingRequest = async () => {
        try {
            const res = await allGroupPendingRequestsAPI.get();
            setGroupPendingRequests(res?.groups);
            setTotalGroupPendingRequest(res?.total);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchPendingRequest();
        fetchFriendRequest();
        fetchGroupRequested();
        fetchAllGroupPendingRequest();

        return () => {
            pendingRequestAPI.abort();
            requestedFriendAPI.abort();
            groupRequestedAPI.abort();
            allGroupPendingRequestsAPI.abort();
        };
    }, []);


    // const onLoadMore = () => {
    //     setLoading(true);
    //     setList(
    //         data.concat([...new Array(count)].map(() => ({loading: true, name: {}, picture: {}}))),
    //     );
    //     fetch(fakeDataUrl)
    //         .then(res => res.json())
    //         .then(res => {
    //             const newData = data.concat(res.results);
    //             setData(newData);
    //             setList(newData);
    //             setLoading(false);
    //             // Resetting window's offsetTop so as to display react-virtualized demo underfloor.
    //             // In real scene, you can using public method of react-virtualized:
    //             // https://stackoverflow.com/questions/46700726/how-to-use-public-method-updateposition-of-react-virtualized
    //             window.dispatchEvent(new Event('resize'));
    //         });
    // };
    //
    // const loadMore =
    //     !initLoading && !loading ? (
    //         <div
    //             style={{
    //                 textAlign: 'center',
    //                 marginTop: 12,
    //                 height: 32,
    //                 lineHeight: '32px',
    //             }}
    //         >
    //             <Button onClick={onLoadMore}>loading more</Button>
    //         </div>
    //     ) : null;
    //
    // useEffect(() => {
    //     fetch(fakeDataUrl)
    //         .then(res => res.json())
    //         .then(res => {
    //             setInitLoading(false);
    //             setData(res.results);
    //             setList(res.results);
    //         });
    // }, []);

    useEffect(() => {
        loadMoreData();
    }, []);

    const loadMoreData = () => {
        if (loading) {
            return;
        }
        setLoading(true);
        fetch('https://randomuser.me/api/?results=10&inc=name,gender,email,nat,picture&noinfo')
            .then(res => res.json())
            .then(body => {
                setData([...data, ...body.results]);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const onDeclineFriendRequest = (id: string) => {

    }

    return (
        <MyCenterMenuLayout>
            {/*<Header color={"light"} style={{*/}
            {/*    backgroundColor: "white",*/}
            {/*    padding: 0,*/}
            {/*    lineHeight: 0,*/}
            {/*    height: "100%",*/}
            {/*    marginBottom: "2.5rem"*/}
            {/*}}>*/}
            {/*    <div className={styles.leadContainer}>*/}
            {/*        <div className={styles.searchContainer}>*/}
            {/*            <div*/}
            {/*                className={styles.searchIcon}*/}
            {/*                style={{backgroundImage: `url(${requestIcon.searchIcon})`}}*/}
            {/*            />*/}
            {/*            <input*/}
            {/*                type="text"*/}
            {/*                className={styles.searchInput}*/}
            {/*                placeholder={t("Search")}*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</Header>*/}
            <Content style={{backgroundColor: "white"}}>
                <Tabs tabBarStyle={{ margin: 0 }} defaultActiveKey="friend-request" onChange={onChange}>
                    <TabPane tab={t("Friend requests") + ` (${requestedFriends.length})`} key="friend-request">
                        <div
                            id="friend-requests-div"
                            style={{
                                height: "calc(100vh - 50px - 15rem)",
                                overflow: 'auto',
                                padding: '0 16px 0 0',
                                // borderTop: '1px solid rgba(140, 140, 140, 0.35)',
                            }}
                            className={styles.scrollbarContainer}
                        >
                            <InfiniteScroll
                                dataLength={requestedFriends.length}
                                next={loadMoreData}
                                hasMore={false}
                                loader={<Skeleton avatar paragraph={{rows: 1}} active/>}
                                endMessage={<Divider style={{ margin: 0}} plain></Divider>}
                                scrollableTarget="friend-requests-div"
                            >
                                <List
                                    className="demo-loadmore-list"
                                    // loading={initLoading}
                                    itemLayout="horizontal"
                                    // loadMore={loadMore}
                                    dataSource={requestedFriends}
                                    renderItem={(item: any) => (
                                        <List.Item>
                                            <Skeleton avatar title={false} loading={item.loading} active>
                                                <Request
                                                    id={item.friend.id}
                                                    avatarURL={item.friend.imageProfileURL}
                                                    name={item.friend.firstname}
                                                    requestedDate={item.updatedAt}
                                                    onDecline={cancelFriend}
                                                    onAccept={acceptRequest}
                                                />
                                            </Skeleton>
                                        </List.Item>
                                    )}
                                />
                            </InfiniteScroll>
                        </div>
                        {/*<Avatar size={68} src="https://joeschmoe.io/api/v1/random" />*/}
                    </TabPane>
                    <TabPane tab={t("Friend pending") + ` (${pendingRequests.length})`} key="friend-pending">
                        <div
                            id="friend-pending-div"
                            style={{
                                height: "calc(100vh - 50px - 15rem)",
                                overflow: 'auto',
                                padding: '0 16px 0 0',
                                // borderTop: '1px solid rgba(140, 140, 140, 0.35)',
                            }}
                            className={styles.scrollbarContainer}
                        >
                            <InfiniteScroll
                                dataLength={pendingRequests.length}
                                next={loadMoreData}
                                hasMore={false}
                                loader={<Skeleton avatar paragraph={{rows: 1}} active/>}
                                endMessage={<Divider style={{ margin: 0}} plain></Divider>}
                                scrollableTarget="friend-pending-div"
                            >
                                <List
                                    className="demo-loadmore-list"
                                    // loading={initLoading}
                                    itemLayout="horizontal"
                                    // loadMore={loadMore}
                                    dataSource={pendingRequests}
                                    renderItem={(item: any) => (
                                        <List.Item>
                                            <Skeleton avatar title={false} loading={item.loading} active>
                                                <Request
                                                    id={item.friend.id}
                                                    avatarURL={item.friend.imageProfileURL}
                                                    name={item.friend.firstname}
                                                    requestedDate={item.updatedAt}
                                                    declineLabel={t("Cancel")}
                                                    acceptLabel={t("Pending")}
                                                    onDecline={delRequestFriend}
                                                    onAccept={() => {

                                                    }}
                                                    disabledAccept
                                                />
                                            </Skeleton>
                                        </List.Item>
                                    )}
                                />
                            </InfiniteScroll>
                        </div>
                    </TabPane>
                    <TabPane tab={t("Group requests") + ` (${totalGroupPendingRequest})`} key="group-requests">
                        <div
                            id="group-pending-div"
                            style={{
                                height: "calc(100vh - 50px - 15rem)",
                                overflow: 'auto',
                                padding: '1.5rem 16px 0 0',
                                // borderTop: '1px solid rgba(140, 140, 140, 0.35)',
                            }}
                            className={styles.scrollbarContainer}
                        >
                            <InfiniteScroll
                                dataLength={pendingRequests.length}
                                next={loadMoreData}
                                hasMore={false}
                                loader={<Skeleton avatar paragraph={{rows: 1}} active/>}
                                // endMessage={<Divider plain></Divider>}
                                scrollableTarget="group-pending-div"
                            >
                                <Collapse
                                    onChange={onChange}
                                    expandIconPosition={'end'}
                                    // defaultActiveKey={['1']}
                                    ghost
                                    // bordered
                                    bordered={false}
                                    // style={{ border: "1px solid gray!important"}}
                                    className="site-collapse-custom-collapse"
                                    // onChange={onChange}
                                    // expandIconPosition={"end"}
                                >
                                    {
                                        groupPendingRequests?.map((req: any) => {
                                            return <Panel showArrow header={
                                                <div style={{ display: "flex"}}>
                                                    <Avatar size={68} src={req.coverImgURL} />
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "center",
                                                        marginLeft: "1rem"
                                                    }}
                                                    >
                                                        <div>
                                                            <span>{req.name}</span>
                                                        </div>
                                                        <div style={{
                                                            display: "flex",
                                                            // justifyContent: "center",
                                                            justifyItems: "center",
                                                            alignItems: "center",
                                                            color: "#0F4C82",
                                                            fontSize: "11px"
                                                        }}>
                                                            <UserOutlined />
                                                            <span style={{ marginLeft: "0.25rem"}}>{req.totalRequest} {t("request pending")}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                            } key={req.id} className={"site-collapse-custom-panel"}>
                                                <GroupRequests
                                                    groupId={req.id}
                                                    onNoRequests={() => {
                                                        setGroupPendingRequests((reqs: any) => reqs.filter((re: any) => {
                                                            return re?.id !== req.id
                                                        }));
                                                        setTotalGroupPendingRequest((prevTotal: number) => prevTotal - 1);
                                                    }}
                                                />
                                            </Panel>
                                        })
                                    }
                                    {/*<Panel showArrow={false} header={*/}
                                    {/*    <div style={{ display: "flex"}}>*/}
                                    {/*        <Avatar size={68} icon={<AntDesignOutlined />} />*/}
                                    {/*        <div style={{*/}
                                    {/*                display: "flex",*/}
                                    {/*                flexDirection: "column",*/}
                                    {/*                justifyContent: "center",*/}
                                    {/*                marginLeft: "1rem"*/}
                                    {/*            }}*/}
                                    {/*        >*/}
                                    {/*            <div>*/}
                                    {/*                <span>ปวดหัววววว</span>*/}
                                    {/*            </div>*/}
                                    {/*            <div style={{*/}
                                    {/*                display: "flex",*/}
                                    {/*                // justifyContent: "center",*/}
                                    {/*                justifyItems: "center",*/}
                                    {/*                alignItems: "center",*/}
                                    {/*                color: "#0F4C82",*/}
                                    {/*                fontSize: "11px"*/}
                                    {/*            }}>*/}
                                    {/*                <UserOutlined />*/}
                                    {/*                <span style={{ marginLeft: "0.25rem"}}>4 request pending</span>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}

                                    {/*} key="1" className={styles.siteCollapseCustomPanel}>*/}
                                    {/*    <GroupRequests*/}
                                    {/*        groupId={"a43b918f-9ea5-42d6-8343-4bc13d8bd986"}*/}
                                    {/*    />*/}
                                    {/*    /!*<List*!/*/}
                                    {/*    /!*    className="demo-loadmore-list"*!/*/}
                                    {/*    /!*    // loading={initLoading}*!/*/}
                                    {/*    /!*    itemLayout="horizontal"*!/*/}
                                    {/*    /!*    // loadMore={loadMore}*!/*/}
                                    {/*    /!*    // style={{ padding: "0 1rem"}}*!/*/}
                                    {/*    /!*    dataSource={pendingRequests}*!/*/}
                                    {/*    /!*    renderItem={(item: any) => (*!/*/}
                                    {/*    /!*        <List.Item style={{borderBottom: "none", paddingTop: 0}}>*!/*/}
                                    {/*    /!*            <Skeleton avatar title={false} loading={item.loading} active>*!/*/}
                                    {/*    /!*                <GroupPending*!/*/}
                                    {/*    /!*                    id={item.friend.id}*!/*/}
                                    {/*    /!*                    imgURL={item.friend.imageProfileURL}*!/*/}
                                    {/*    /!*                    name={item.friend.firstname}*!/*/}
                                    {/*    /!*                    date={item.updatedAt}*!/*/}
                                    {/*    /!*                    onDecline={delRequestFriend}*!/*/}
                                    {/*    /!*                    onAccept={() => {*!/*/}

                                    {/*    /!*                    }}*!/*/}
                                    {/*    /!*                />*!/*/}
                                    {/*    /!*            </Skeleton>*!/*/}
                                    {/*    /!*        </List.Item>*!/*/}
                                    {/*    /!*    )}*!/*/}
                                        {/*/>*/}
                                    {/*</Panel>*/}
                                    {/*<Panel showArrow={false} header="This is panel header 2" key="2" className={styles.siteCollapseCustomPanel}>*/}
                                    {/*    <div>This is panel header 1</div>*/}
                                    {/*</Panel>*/}
                                    {/*<Panel showArrow={false} header="This is panel header 3" key="3" className={styles.siteCollapseCustomPanel}>*/}
                                    {/*    <div>This is panel header 1</div>*/}
                                    {/*</Panel>*/}
                                </Collapse>
                            </InfiniteScroll>
                        </div>
                    </TabPane>
                    <TabPane tab={t("Group pending") + ` (${groupRequests.length})`} key="group-pending">
                        <div
                            id="group-pending-div"
                            style={{
                                height: "calc(100vh - 50px - 15rem)",
                                overflow: 'auto',
                                padding: '0 16px 0 0',
                                // borderTop: '1px solid rgba(140, 140, 140, 0.35)',
                            }}
                            className={styles.scrollbarContainer}
                        >
                            <InfiniteScroll
                                dataLength={groupRequests.length}
                                next={loadMoreData}
                                hasMore={false}
                                loader={<Skeleton avatar paragraph={{rows: 1}} active/>}
                                endMessage={<Divider style={{ margin: 0}} plain></Divider>}
                                scrollableTarget="group-pending-div"
                            >
                                <List
                                    className="demo-loadmore-list"
                                    // loading={initLoading}
                                    itemLayout="horizontal"
                                    // loadMore={loadMore}
                                    dataSource={groupRequests}
                                    renderItem={(item: any) => (
                                        <List.Item>
                                            <Skeleton avatar title={false} loading={item.loading} active>
                                                <Request
                                                    id={item.group?.id}
                                                    avatarURL={item.group?.coverImgURL}
                                                    name={item.group?.name}
                                                    requestedDate={item?.updatedAt}
                                                    declineLabel={t("Cancel")}
                                                    acceptLabel={t("Pending")}
                                                    onDecline={cancelGroup}
                                                    onAccept={() => {

                                                    }}
                                                    disabledAccept
                                                />
                                            </Skeleton>
                                        </List.Item>
                                    )}
                                />
                            </InfiniteScroll>
                        </div>
                    </TabPane>
                </Tabs>
            </Content>
        </MyCenterMenuLayout>
    )
}

export default Requests